import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImportedInvoiceDetailDividerWrapper = styled.hr`
  height: 4px;
  margin: 0;
  border: none;
  background-color: ${Color.Grey100};
`
